import { Controller } from "@hotwired/stimulus"

// Smoothly scrolls to a target element when triggered
export default class extends Controller {
  static values = {
    target: String
  }

  scroll(event) {
    const selector = this.targetValue || this.element.getAttribute("href")
    if (!selector) return

    const target = document.querySelector(selector)
    if (!target) return

    event.preventDefault()
    target.scrollIntoView({ behavior: "smooth", block: "start" })
  }

    delayed_scroll(event) {
        setTimeout(() => {
            const selector = this.targetValue || this.element.getAttribute("href")
            if (!selector) return

            const target = document.querySelector(selector)
            if (!target) return

            event.preventDefault()

            target.scrollIntoView({ behavior: "smooth", block: "start" })
        }, 400)
    }
}
